import EventCover from './EventCover';

export default EventCover;